var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.382,
    height: 35.381,
    viewBox: "0 0 35.382 35.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 35.382,
    height: 35.381,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69266",
    "data-name": "Path 69266",
    d: "M35.382,17.691A17.691,17.691,0,1,1,17.691,0,17.691,17.691,0,0,1,35.382,17.691",
    fill: "#00d95f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69267",
    "data-name": "Path 69267",
    d: "M8.132,27.7l1.475-5.5a10.19,10.19,0,1,1,4.057,4.021Zm5.807-3.544.348.208a8.272,8.272,0,1,0-2.828-2.8l.213.35-.823,3.073Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69268",
    "data-name": "Path 69268",
    d: "M22.275,18.7a1.711,1.711,0,0,0-1.455-.328c-.378.155-.62.747-.864,1.049a.362.362,0,0,1-.469.1A6.585,6.585,0,0,1,16.2,16.708a.4.4,0,0,1,.05-.551,2.227,2.227,0,0,0,.6-.97,2.125,2.125,0,0,0-.267-1.149,2.714,2.714,0,0,0-.848-1.277,1.162,1.162,0,0,0-1.261.187,2.561,2.561,0,0,0-.888,2.029,2.846,2.846,0,0,0,.08.644,5.335,5.335,0,0,0,.617,1.423,11.2,11.2,0,0,0,.645.981,9.934,9.934,0,0,0,2.8,2.6,8.453,8.453,0,0,0,1.744.83,3.883,3.883,0,0,0,2.03.32,2.455,2.455,0,0,0,1.84-1.369,1.187,1.187,0,0,0,.086-.7c-.1-.481-.757-.767-1.146-1",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogo);
export default __webpack_public_path__ + "static/media/whatsapp_logo.8cef4fa7124d6e971bf41d3ec74e8bdc.svg";
export { ForwardRef as ReactComponent };